import { render } from "./ClientContactCard.vue?vue&type=template&id=f9a77e8e"
import script from "./ClientContactCard.vue?vue&type=script&lang=js"
export * from "./ClientContactCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__